<hawk-record-navigation [root]="'customer'" [leafDescription]="'Eichämter'" class="app-page">
  <!-- Die PLZ-Prüfung ist die Aktion dieser Seite und gehört deshalb in die
       Toolbar — wie der Schnellfilter bei den PickPoint-Stationen. -->
  <div slot="toolbar" class="flex flex-row gap-2 items-center">
    <input
      type="text"
      class="bm-input"
      placeholder="PLZ, z. B. 32049"
      [(ngModel)]="postalCodeQuery"
      (keyup.enter)="runLookup()"
    />
    <input
      type="text"
      class="bm-input"
      placeholder="Ort (nur bei Landesgrenzen)"
      [(ngModel)]="cityQuery"
      (keyup.enter)="runLookup()"
    />
    <button class="bm-btn bm-btn-primary" (click)="runLookup()" [disabled]="lookupRunning">
      <fa-icon [icon]="faSearch"></fa-icon>
      Zuständigkeit prüfen
    </button>
  </div>

  <div class="page-content page-frame overflow-auto">
    <div class="page-sheet max-w-7xl mx-auto flex flex-col gap-4">
      @if (lookupResult) {
        <div class="bm-card bm-card-sm border border-base-300">
          <div class="bm-card-body">
            <div class="bm-card-title">Zuständigkeit für PLZ {{ lookupResult.postal_code }}</div>

            <div
              class="bm-alert text-sm"
              [class.bm-alert-success]="lookupOk"
              [class.bm-alert-warning]="!lookupOk"
            >
              <fa-icon [icon]="lookupOk ? faCheck : faExclamationTriangle"></fa-icon>
              <span>{{ lookupResult.reason }}</span>
            </div>

            @if (lookupResult.office) {
              <dl class="bm-dl gap-x-2">
                <dt>Eichamt</dt>
                <dd>{{ lookupResult.office.name }}</dd>
                <dt>E-Mail</dt>
                <dd>{{ lookupResult.office.email }}</dd>
                <dt>Anschrift</dt>
                <dd>
                  {{ lookupResult.office.street }}, {{ lookupResult.office.postal_code }}
                  {{ lookupResult.office.city }}
                </dd>
              </dl>
            }

            <!-- Bei Mehrdeutigkeit die Kandidaten zeigen, sonst weiß der
                 Bearbeiter nicht, wonach er den Ort auswählen soll. -->
            @if (lookupResult.status === 'ambiguous' && lookupResult.candidates.length) {
              <dl class="bm-dl gap-x-2">
                <dt>Infrage kommend</dt>
                <dd>
                  @for (kandidat of lookupResult.candidates; track kandidat.id) {
                    <div>{{ kandidat.name }}</div>
                  }
                </dd>
              </dl>
            }
          </div>
        </div>
      }

      <div class="bm-card bm-card-sm border border-base-300">
        <div class="bm-card-body">
          <div class="bm-card-title">Eichämter</div>

          @if (loading) {
            <div class="flex justify-center py-8">
              <span class="loading loading-spinner loading-lg"></span>
            </div>
          }

          @if (!loading && overview) {
            <div class="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-base-content/70">
              <span>{{ overview.offices.length }} Ämter</span>
              <span>{{ overview.postal_code_count }} zugeordnete PLZ</span>
              <span>{{ overview.coverage.length }} Bundesländer</span>
            </div>

            <div class="overflow-x-auto">
              <table class="bm-table bm-table-sm">
                <thead>
                  <tr>
                    <th>Eichamt</th>
                    <th>E-Mail</th>
                    <th>Anschrift</th>
                    <th class="text-right">PLZ</th>
                  </tr>
                </thead>
                <tbody>
                  @for (office of overview.offices; track office.id) {
                    <tr>
                      <td>{{ office.name }}</td>
                      <td>
                        @if (office.deliverable) {
                          {{ office.email }}
                        } @else {
                          <span class="flex items-center gap-1 text-warning">
                            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                            keine Mailadresse
                          </span>
                        }
                      </td>
                      <td>{{ office.street }}, {{ office.postal_code }} {{ office.city }}</td>
                      <td class="text-right">{{ office.postal_code_count }}</td>
                    </tr>
                  }
                  @empty {
                    <tr>
                      <td colspan="4" class="text-center text-base-content/60">
                        Noch keine Eichämter importiert.
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>

      @if (!loading && overview) {
        <div class="bm-card bm-card-sm border border-base-300">
          <div class="bm-card-body">
            <div class="bm-card-title">Abdeckung nach Bundesland</div>
            <div class="flex flex-wrap gap-2">
              @for (eintrag of overview.coverage; track eintrag.state) {
                <span class="bm-badge bm-badge-outline">
                  {{ eintrag.state || "ohne Bundesland" }}: {{ eintrag.count }}
                </span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</hawk-record-navigation>
